import { Theme } from "@mui/material/styles";
import styled from "@mui/material/styles/styled";
import useTheme from "@mui/material/styles/useTheme";
import React from "react";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useHistory, useLocation } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles/makeStyles";
import { AiFillHome } from "react-icons/ai";
import { Badge, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import routes from "../../utils/routes.json";
import logo from "../../Assests/in5.png";
import { IonContent, IonFooter } from "@ionic/react";
import Header from "../Header";
import { MdOutlinePayments } from "react-icons/md";
import { MdOutlineLightbulb } from "react-icons/md";
import { MdLogout } from "react-icons/md";
import { userDispatch } from "../../utils/localStorage";
import { FaRegUser } from "react-icons/fa6";
import { FaRegCalendar } from "react-icons/fa";
import { BsQuestionCircle } from "react-icons/bs";
import { MdHome } from "react-icons/md";
import { LiaHomeSolid } from "react-icons/lia";
import { HiShoppingCart } from "react-icons/hi";
import { HiOutlineShoppingCart } from "react-icons/hi2";
import { IoTicketOutline } from "react-icons/io5";
import { IoTicketSharp } from "react-icons/io5";
import { getBookings } from "../../utils/services";
import { calculateCartCount } from "../../utils/helpers";

const drawerWidth = 240;
const bottomMenuHeight = 90;

const useStyles = makeStyles((theme: Theme) => ({
  Drawer: {
    "& .MuiDrawer-paper": {
      backgroundColor: `#2D2146 !important`,
      borderRight: "none",
      borderRadius: "0px",
      position: "relative",
    },
  },
  mobileDrawer: {
    "& .MuiDrawer-paper": {
      backgroundColor: `#fff !important`,
      borderRadius: "0px",
      padding: "48px 24px",
      minWidth: "300px",
      overflow: "hidden",
    },
  },
  mobileFooter: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    position: "fixed",
    bottom: "0px",
    background: "#fff",
    padding: "8px 50px",
    height: `${bottomMenuHeight}px`,
  },
  mobileContentHeight: {
    height: `calc(92vh - ${bottomMenuHeight + 10}px)`,
    [theme.breakpoints.down("md")]: {
      height: `calc(92vh - 80px)`,
    },
  },
  mobileContentHeightNormal: {
    [theme.breakpoints.down("md")]: {
      height: `90vh`,
    },
  },
  mobileContent: {
    overflow: "scroll",
    background: "#f6f8fb",
  },
  mainContent: {
    position: "relative",
    flexGrow: 1,
    overflow: "auto",
    background: "#F6F8FB",
    height: "100%",
    padding: "20px 20px",
  },
  mainContent2: {
    position: "relative",
    flexGrow: 1,
    overflow: "hidden",
    background: "#F6F8FB",
    height: "100%",
    padding: "20px 20px",
  },
  logo: {
    height: "36px",
    width: "36px",
    objectFit: "contain",
    background: "#fff",
    borderRadius: "4px",
    padding: "2px",
  },
}));

const Drawer = styled(MuiDrawer)(() => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  overflowX: "hidden",
  "& .MuiDrawer-paper": {
    width: drawerWidth,
  },
}));

const appStructure: any = {
  facilities: {
    header: "variant1",
    sideNav: true,
    mobileHeader: "variant2",
    mobileFooter: true,
  },
  facilityDetails: {
    header: "variant2",
    sideNav: false,
    mobileHeader: "variant1",
    mobileFooter: false,
    breadCrumbs: ["Facilities", "Meeting rooms"],
  },
  "meeting rooms": {
    mobileHeader: "variant1",
    mobileFooter: false,
  },
  "book facility": {
    mobileHeader: "variant1",
    mobileFooter: false,
  },
  cart: {
    header: "variant2",
    sideNav: false,
    mobileHeader: "variant1",
    mobileFooter: true,
    breadCrumbs: ["Meeting rooms", "Checkout"],
  },
  "billing details": {
    mobileHeader: "variant1",
    mobileFooter: false,
  },
  "contact admin": {
    mobileHeader: "variant1",
    mobileFooter: false,
  },
  "change password": {
    mobileHeader: "variant1",
    mobileFooter: false,
  },
  bookings: {
    header: "variant1",
    sideNav: true,
    mobileHeader: "variant2",
    mobileFooter: true,
    breadCrumbs: [],
  },
  transactions: {
    header: "variant1",
    sideNav: true,
    mobileHeader: "variant2",
    mobileFooter: true,
    breadCrumbs: [],
  },
  notifications: {
    mobileHeader: "variant1",
    mobileFooter: false,
  },
  calendar: {
    header: "variant2",
    sideNav: true,
    mobileHeader: "variant2",
    mobileFooter: true,
  },
  "my profile": {
    header: "variant2",
    sideNav: true,
    mobileHeader: "variant2",
    mobileFooter: true,
  },
};

const SideNavigation: React.FunctionComponent<any> = ({ children }) => {
  const classes = useStyles();
  const themes: Theme = useTheme();
  const navigate = useHistory();
  const isMobileScreen: boolean = useMediaQuery(themes.breakpoints.down("sm"));

  const [user, setUser] = useState<any>();
  const [mobileDrawer, setMobileDrawer] = useState<boolean>(false);
  const [cartCount, setCartCount] = useState<number>(0);

  const handleMobileDrawer = () => {
    setMobileDrawer(!mobileDrawer);
  };

  const mobileDrawerMenus: any[] = [
    {
      label: "My profile",
      icons: () => {
        return <FaRegUser color="#6A4EA6" style={{ height: "22px", width: "22px" }} />;
      },
    },
    {
      label: "Calendar",
      icons: () => {
        return <FaRegCalendar color="#6A4EA6" style={{ height: "22px", width: "22px" }} />;
      },
    },
    // {
    //   label: "Transactions",
    //   icons: () => {
    //     return <MdOutlinePayments color="#6A4EA6" style={{ height: "22px", width: "22px" }} />;
    //   },
    // },
    // {
    //   label: "Service & Support",
    //   icons: () => {
    //     return <BsQuestionCircle color="#6A4EA6" style={{ height: "22px", width: "22px" }} />;
    //   },
    // },
  ];

  const phoneMenus: any[] = [
    {
      label: "My Bookings",
      routes: routes.bookings,
      activeIcons: <IoTicketSharp color="#604797" fontSize={"28px"} />,
      icons: <IoTicketOutline fontSize={"24px"} />,
      routeLabel: "bookings",
    },
    {
      label: "Facilities",
      routes: routes.facilities,
      activeIcons: <MdHome color="#604797" fontSize={"28px"} />,
      icons: <LiaHomeSolid fontSize={"24px"} />,
      routeLabel: "facilities",
    },
    {
      label: "Cart",
      routes: routes.facilitiesCart,
      activeIcons: <HiShoppingCart color="#604797" fontSize={"28px"} />,
      icons: <HiOutlineShoppingCart fontSize={"24px"} />,
      routeLabel: "cart",
    },
  ];

  const { pathname } = useLocation();
  const pathKey = pathname.split("/")[1];

  const ListTabs: React.FunctionComponent = () => {
    return (
      <>
        <List className="w-100" component="nav">
          <ListItemButton
            onClick={() => {
              navigate.push(routes.facilities);
            }}
            style={{
              background: pathKey == "facilities" ? "#8871B8" : "transparent",
              borderLeft: pathKey === "facilities" ? "4px solid #E6E6E6" : "4px solid transparent",
              margin: "15px 0px",
            }}
          >
            <ListItemIcon>{pathKey === "facilities" ? <AiFillHome style={{ height: "24px", width: "24px", color: "#FFFFFF" }} /> : <MdOutlineLightbulb style={{ height: "24px", width: "24px", color: "#FFFFFF" }} />}</ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="medium" color={"#E6E6E6"}>
                  Facilities
                </Typography>
              }
            />
          </ListItemButton>
          <ListItemButton
            onClick={() => {
              navigate.push(routes.bookings);
            }}
            style={{
              background: pathKey == "bookings" ? "#8871B8" : "transparent",
              borderLeft: pathKey == "bookings" ? "4px solid #E6E6E6" : "4px solid transparent",
              margin: "15px 0px",
            }}
          >
            <ListItemIcon>
              <IoTicketOutline style={{ height: "24px", width: "24px", color: "#FFFFFF" }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="medium" color={"#E6E6E6"}>
                  My Bookings
                </Typography>
              }
            />
          </ListItemButton>
        </List>
      </>
    );
  };

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await userDispatch({ case: "GET", key: "user" });
        setUser(res);
      } catch (err) {
        console.error(err);
      }
    };
    getUser();
  }, []);

  useEffect(() => {
    if (user) {
      getBookings()
        .then((res) => {
          if (res.data.status === "true") {
            const count = calculateCartCount(res.data.result || []);
            setCartCount(count);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [pathname, user]);

  return (
    <>
      {isMobileScreen ? (
        <Box
          component={"section"}
          style={{
            position: "relative",
            height: "100vh",
          }}
        >
          <Header handleMobileDrawer={handleMobileDrawer} mobileHeaderVariant={appStructure[pathKey].mobileHeader} cartCount={cartCount} />
          <Drawer className={classes.mobileDrawer} open={mobileDrawer} onClose={handleMobileDrawer}>
            <Box component={"div"} className="d-flex flex-column" gap={"32px"}>
              <Box component={"div"} className="d-flex flex-column" gap={"8px"}>
                <Box component={"img"} src={logo} height={"60px"} width={"36px"} sx={{ objectFit: "contain" }} />
                <Box component={"div"} className="d-flex flex-column" gap={"4px"}>
                  <Typography component={"h6"} color={"#333333"} variant="medium">
                    in5
                  </Typography>
                  <Typography component={"h6"} color={"#333333"} variant="extrasmallthin">
                    {user?.name}
                  </Typography>
                </Box>
              </Box>
              <Box component={"div"} sx={{ height: "1px", background: "#F0EDF6" }} />
              <Box component={"div"} className="d-flex flex-column" gap={"32px"}>
                {mobileDrawerMenus.map((items, index) => {
                  return (
                    <Box component={"div"} key={index} className="d-flex align-items-center" gap={"12px"}>
                      {items?.icons()}
                      <Typography color={"#333333"} variant="smallmedium" component={"h6"}>
                        {items?.label}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            {user?.id && (
              <Box
                component={"div"}
                className="d-flex flex-column w-100"
                gap={"24px"}
                sx={{
                  bottom: "70px",
                  position: "absolute",
                }}
              >
                <Box component={"div"} sx={{ height: "1px", width: "78%", background: "#F0EDF6" }} />
                <Box
                  component={"div"}
                  className="d-flex align-items-center"
                  gap={"12px"}
                  onClick={async () => {
                    await userDispatch({ case: "CLEAR" });
                    navigate.push("/");
                  }}
                >
                  <MdLogout color="#6A4EA6" style={{ height: "22px", width: "22px" }} />
                  <Typography color={"#333333"} variant="smallmedium" component={"h6"}>
                    Logout
                  </Typography>
                </Box>
              </Box>
            )}
          </Drawer>
          <IonContent>
            <div className={`${classes.mobileContent} ${appStructure[pathKey].mobileFooter ? classes.mobileContentHeight : classes.mobileContentHeightNormal}`}>{children}</div>
          </IonContent>
          {appStructure[pathKey].mobileFooter && (
            <IonFooter className={classes.mobileFooter}>
              {phoneMenus.map((items: any, index: number) => {
                return (
                  <Box component={"div"} className="d-flex flex-column align-items-center" gap={"2px"} key={index}>
                    <IconButton
                      onClick={() => {
                        navigate.push(items.routes);
                      }}
                    >
                      {items?.label === "Cart" && cartCount > 0 ? (
                        <Badge
                          badgeContent={cartCount}
                          color="primary"
                          sx={{
                            "& .MuiBadge-badge": {
                              background: "#  604797",
                            },
                          }}
                        >
                          {items.routeLabel === pathKey ? items.activeIcons : items.icons}
                        </Badge>
                      ) : items.routeLabel === pathKey ? (
                        items.activeIcons
                      ) : (
                        items.icons
                      )}
                    </IconButton>
                    {items.routeLabel === pathKey && (
                      <Typography variant="smallmedium" component={"h6"} lineHeight={"20px"} color={"#604797"}>
                        {items.label}
                      </Typography>
                    )}
                  </Box>
                );
              })}
            </IonFooter>
          )}
        </Box>
      ) : (
        <>
          {!appStructure[pathKey]?.sideNav ? (
            <Box component="main" display="flex" width={"100%"} flexDirection="column" height="100vh">
              <Box component="div" position="sticky" top={0}>
                <Header headerVariant={appStructure[pathKey].header} breadCrumbs={appStructure[pathKey]?.breadCrumbs} cartCount={cartCount} />
              </Box>
              <IonContent>
                <Box component="div" className={classes.mainContent2}>
                  {children}
                </Box>
              </IonContent>
            </Box>
          ) : (
            <div className="d-flex">
              <Drawer className={classes.Drawer} variant="permanent" open={true}>
                <Box component={"div"} padding={"23px 20px 23px 20px"} className="d-flex align-items-center gap-2">
                  <Box component={"img"} src={logo} className={classes.logo} />
                  <Typography variant="smallmedium" color={"#E6E6E6 "}>
                    in5
                  </Typography>
                </Box>
                <ListTabs />
                {user?.id && (
                  <ListItemButton
                    onClick={async () => {
                      await userDispatch({ case: "CLEAR" });
                      navigate.push("/");
                    }}
                    style={{
                      background: "transparent",
                      borderLeft: "4px solid transparent",
                      margin: "15px 0px",
                      bottom: "20px",
                      position: "absolute",
                    }}
                  >
                    <ListItemIcon>
                      <MdLogout
                        style={{
                          height: "24px",
                          width: "24px",
                          color: "#FFFFFF",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="medium" color={"#E6E6E6"}>
                          Logout
                        </Typography>
                      }
                    />
                  </ListItemButton>
                )}
              </Drawer>
              <Box component="main" display="flex" width={"100%"} flexDirection="column" height="100vh">
                <Box component="div" position="sticky" top={0}>
                  <Header headerVariant={appStructure[pathKey].header} cartCount={cartCount} />
                </Box>
                <IonContent>
                  <Box
                    component="div"
                    className={classes.mainContent}
                    sx={{
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                    }}
                  >
                    {children}
                  </Box>
                </IonContent>
              </Box>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SideNavigation;
